import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const ACTIVITY_SCREENSHOT = `${API_URL}/api/v1/kid/activity`;
export const PUSH_SCREENSHOT = `${API_URL}/api/v1/parent/push-notification`;
export const MANUAL_SCREENSHOT = `${API_URL}/api/v1/parent/manual-screenshot`;
export const DELETE_SCREENSHOT = `${API_URL}/api/v1/parent/delete-activity`;
export const SCREENSHOT_CATEGORY = `${API_URL}/api/v1/parent/app-categories`;
export const CATEGRORY_WISE_APPS = `${API_URL}/api/v1/parent/category-apps`;

export function getManualScreenshotList(data) {
    data['itemsPerPage'] = 100
    data['pageNo'] = 1
    return axiosInstance({
        url: MANUAL_SCREENSHOT,
        method: "GET",
        params: data
    })
}
export function getActivityScreenshotList(data) {
    const { kidId, deviceId, deletedImages, changeOneDate, nowTime, appPackageNames } = data;
    const payload = {
        kidId,
        deviceId,
        isDeletedImages: deletedImages,
        activityType: 'SCREENSHOTS',
        startDate: changeOneDate,
        endDate: nowTime,
        pageNo: 1,
        itemsPerPage: 9999999
    }

    if(appPackageNames) {
        payload['appPackageNames'] = appPackageNames
    }

    // let url;
    // if (appPackageNames) {
    //     url = `${ACTIVITY_SCREENSHOT}?kidId=${kidId}&deviceId=${deviceId}&isDeletedImages=${deletedImages}&activityType=${"SCREENSHOTS"}&startDate=${changeOneDate}&endDate=${nowTime}&pageNo=1&itemsPerPage=9999999&&appPackageNames=${appPackageNames}`
    // } else {
    //     url = `${ACTIVITY_SCREENSHOT}?kidId=${kidId}&deviceId=${deviceId}&isDeletedImages=${deletedImages}&activityType=${"SCREENSHOTS"}&startDate=${changeOneDate}&endDate=${nowTime}&pageNo=1&itemsPerPage=9999999&`
    // }



    return axiosInstance({
        url: ACTIVITY_SCREENSHOT,
        method: "GET",
        params: payload
    })
}
export function pushScreenshotApi(data) {
    return axiosInstance({
        url: PUSH_SCREENSHOT,
        method: "POST",
        data
    })
}
export function deleteScreenshot(payload) {
    return axiosInstance({
        url: DELETE_SCREENSHOT,
        method: "POST",
        data: payload
    })
}
export function getScreenshotCategories(data) {
    // const { userId, deviceId } = data;
    data['categoryType'] = 1
    return axiosInstance({
        url: SCREENSHOT_CATEGORY,
        method: "GET",
        params: data
    })
}
export function getCategoryWiseApps(data) {
    const { categoryId : catIds, deviceId } = data;
    const categoryId = catIds?.join(",");
    return axiosInstance({
        url: CATEGRORY_WISE_APPS,
        method: "GET",
        params: {
            categoryId, deviceId
        }
    })
}